/* eslint-disable */
import React, { useEffect } from 'react';
import DataList from '../../sharedcomponents/dataList/dataList';
import { useState, Downgraded } from '@hookstate/core';
import { Paper, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import UserListDialog from '../../sharedcomponents/userList/userListDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import { useAuthState } from '../../stores/authStore';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import EditTemplate from '../../modules/Invitation/editTemplate';
import EditInvitationList from '../../modules/Invitation/editInvitationList';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import SendEmail from '../../modules/Invitation/sendEmail';
import
{
    NO_ACCESS_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import { excelFileType } from '../../constants/Constant';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: '16px',
        },
    },
}));
const InvitationList = (props) =>
{
    const loading = useState(false);
    const openDialog = useState(false);
    const classes = useStyles();
    const invitationList = useState(null);
    const allInvitationInfo = useState()
    const overallParticipants = useState([]);
    const users = useState([]);
    const authState = useAuthState();
    const eventState = useState([]);
    const fullData = useState([]);
    // const eventStateDetail = useEventState();
    const eventData = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const openUserDialog = useState(false);
    const invitationInfo = useState(null);
    const openEditTemplate = useState(false);
    const openSendEmail = useState(false);
    const [showLoading, setShowLoading] = React.useState(false);
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const emailLoading = useState({
        loading: false,
        index: 0
    });
    const editLoading = useState({
        loading: false,
        index: 0
    });

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [templateInfo, setTemplateInfo] = React.useState([]);
    const userID = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    // const [modPermission, setModPermission] = React.useState(null);

    useEffect(() =>
    {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        )
        {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        )
        {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);
    useEffect(()=>{
        const userInfo = Helper.getStorage('userInfo');
        if(Helper.isAdminUser(userInfo)){
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage:5000,
                noOfPages: pagingInfo.get().noOfPages,
            });
        }
    },[])
    // useEffect(() => {
    //     const userInfo = Helper.getStorage('userInfo');

    //     if (eventStateDetail) {
    //         if (Helper.isAdminUser(userInfo)) {
    //             setModPermission(FULL_PERMISSION);
    //         }
    //         else if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
    //             setModPermission(FULL_PERMISSION);
    //         }
    //         else {
    //             setModPermission(NO_ACCESS_PERMISSION);
    //         }
    //     }
    // }, [eventStateDetail]);

    useEffect(() =>
    {
        if (
            props.modPermission &&
            props.modPermission != NO_ACCESS_PERMISSION
        )
        {
            const fetchDetails = async () =>
            {
                let usersList = await getInvitationList();
                if (eventState && eventState.get().length == 0)
                {
                    const eventInfo = Helper.getStorage('eventInfo');
                    ApiHelper.get(
                        APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                            eventInfo.eventID
                        )
                    )
                        .then((res) =>
                        {
                            let newEventState = res.data.rows;
                            let originalUsers = usersList;
                            let filteredEventState = newEventState.filter(
                                (x) =>
                                    !originalUsers
                                        .map((y) => y.actualData.userID)
                                        .includes(x.userID)
                            );
                            eventState.set(filteredEventState);
                            overallParticipants.set(res.data.rows);
                        })
                        .catch((err) =>
                        {
                            //... Check if user's session has expired
                            if (err.response && err.response.status === 401)
                            {
                                console.log(err);
                            }
                        });
                }
            };
            fetchDetails();

            ApiHelper.get(
                APIURLConstants.GET_TEMPLATES(eventData.get().eventID)
            ).then((res) =>
            {
                setTemplateInfo(res.data);
            });

            // const pageInfo = pagingInfo.attach(Downgraded).get();
            // if (pageInfo.itemsPerPage)
            // {
            //     getInvitationList();
            // }
        }
    }, [props.modPermission]);

    const getInvitationList = () =>
    {
        let allData;
        loading.set(true);
        return ApiHelper.get(
            APIURLConstants.GET_INVITATION_LIST(
                eventData.get().eventID,
                1,
                5000
            )
        )
            .then((res) =>
            {
                let data = res.data.invitations;
                allData = res;
                allInvitationInfo.set(data)
                let usersData = [];
                let allrequestData = [];
                const indexOfLastRecord = pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
                    const indexOfFirstRecord = indexOfLastRecord - pagingInfo.get().itemsPerPage;
                if (data.length > 0)
                {
                    data.map((item) =>
                    {
                        if (item.status === 0)
                        {
                            allrequestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'invitationID',
                                        invitationID: item.invitationID,
                                        width: '0.05',
                                    },

                                    {
                                        label: 'Name',
                                        key: 'participant',
                                        participant: item.participant,
                                        showLabel: false,
                                        width: '0.25',
                                        inColumn: true,
                                        showEmail: true,
                                        toEmail: item.emailID,
                                    },

                                    {
                                        label: 'cc',
                                        key: 'ccEmailID',
                                        ccEmailID: item.ccEmailID,
                                        width: '0.2',
                                        inColumn: true,
                                        showTooltip: true,
                                        wrapAll: true,
                                    },

                                    {
                                        label: 'bcc',
                                        key: 'bccEmailID',
                                        bccEmailID: item.bccEmailID,
                                        width: '0.2',
                                        inColumn: true,
                                        showTooltip: true,
                                        wrapAll: true,
                                    },

                                    {
                                        label: 'Status',
                                        key: 'status',
                                        status:
                                            item.status == 0
                                                ? 'Pending'
                                                : 'Sent' +
                                                ' On ' +
                                                Helper.FormatDate(
                                                    item.sentDateTime
                                                ) +
                                                ' @ ' +
                                                Helper.FormatTime(
                                                    item.sentDateTime
                                                ),
                                        width: item.attachments.length > 0 ? '0.255' : '0.27',
                                        inColumn: true,
                                        isSent: true,
                                    },
                                    {
                                        label: 'Attachment',
                                        key: 'attachments',
                                        showLabel: false,
                                        width: '0.02',
                                        showAttachmentIcon:
                                            item.attachments.length > 0
                                                ? true
                                                : false,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'edit',
                                        edit: 'Edit',
                                        width: '0.02',
                                    },
                                    {
                                        label: 'SenMail',
                                        key: 'sendMail',
                                        showLabel: false,
                                        width: '0.02',
                                        showEmailIcon: true,
                                    },

                                    { showChips: true },
                                ],

                                selected: false,
                            });
                        }
                    });
                    fullData.set(allrequestData)
                    usersData = allrequestData;
                //     data.slice(indexOfFirstRecord, indexOfLastRecord).map((item) =>
                //     {
                //         if (item.status === 0)
                //         {
                //             usersData.push({
                //                 actualData: item,
                //                 row: [
                //                     {
                //                         label: 'checkbox',
                //                         key: 'invitationID',
                //                         invitationID: item.invitationID,
                //                         width: '0.05',
                //                     },

                //                     {
                //                         label: 'Name',
                //                         key: 'participant',
                //                         participant: item.participant,
                //                         showLabel: false,
                //                         width: '0.25',
                //                         inColumn: true,
                //                         showEmail: true,
                //                         toEmail: item.emailID,
                //                     },

                //                     {
                //                         label: 'cc',
                //                         key: 'ccEmailID',
                //                         ccEmailID: item.ccEmailID,
                //                         width: '0.2',
                //                         inColumn: true,
                //                         showTooltip: true,
                //                         wrapAll: true,
                //                     },

                //                     {
                //                         label: 'bcc',
                //                         key: 'bccEmailID',
                //                         bccEmailID: item.bccEmailID,
                //                         width: '0.2',
                //                         inColumn: true,
                //                         showTooltip: true,
                //                         wrapAll: true,
                //                     },

                //                     {
                //                         label: 'Status',
                //                         key: 'status',
                //                         status:
                //                             item.status == 0
                //                                 ? 'Pending'
                //                                 : 'Sent' +
                //                                 ' On ' +
                //                                 Helper.FormatDate(
                //                                     item.sentDateTime
                //                                 ) +
                //                                 ' @ ' +
                //                                 Helper.FormatTime(
                //                                     item.sentDateTime
                //                                 ),
                //                         width: item.attachments.length > 0 ? '0.255' : '0.27',
                //                         inColumn: true,
                //                         isSent: true,
                //                     },
                //                     {
                //                         label: 'Attachment',
                //                         key: 'attachments',
                //                         showLabel: false,
                //                         width: '0.02',
                //                         showAttachmentIcon:
                //                             item.attachments.length > 0
                //                                 ? true
                //                                 : false,
                //                     },
                //                     {
                //                         label: 'Action',
                //                         key: 'edit',
                //                         edit: 'Edit',
                //                         width: '0.02',
                //                     },
                //                     {
                //                         label: 'SenMail',
                //                         key: 'sendMail',
                //                         showLabel: false,
                //                         width: '0.02',
                //                         showEmailIcon: true,
                //                     },

                //                     { showChips: true },
                //                 ],

                //                 selected: false,
                //             });
                //         }
                //     });
                }
                invitationList.set(usersData);
                users.set(usersData);
                if (pagingInfo.get().noOfPages == null)
                {
                    pagingInfo.set({
                        ...pagingInfo,
                        currentPage: pagingInfo.get().currentPage,
                        itemsPerPage: pagingInfo.get().itemsPerPage,
                        noOfPages: Math.ceil(
                            res.data.totalCount / pagingInfo.get().itemsPerPage
                        ),
                    });
                }
                if (
                    overallParticipants &&
                    overallParticipants.get().length !== 0
                )
                {
                    let newEventState = overallParticipants
                        .attach(Downgraded)
                        .get();
                    let filteredEventState = newEventState.filter(
                        (x) =>
                            !usersData
                                .map((y) => y.actualData.userID)
                                .includes(x.userID)
                    );
                    eventState.set(filteredEventState);
                }
                loading.set(false);
                props.getSentData(allData)
                return usersData;

            })
            .catch((err) =>
            {
                console.log(err);
                loading.set(false);
                props.getSentData(null)
                return [];

            });
    };
    const editAll = () =>
    {
        const selected = invitationList
            .get()
            .filter((user) => user.selected === true);
            const selected1 = fullData.get().filter((user) => user.selected === true);
            if (selected.length === 0 && selected1.length===0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Invitation first',
            });
        } else
        {
            let selectedIds = [];
            let templateIDs = [];
            let data = [];
            let templateDetails;
            invitationList.get().map((user) =>
            {
                if (user.selected === true)
                {
                    selectedIds.push(user.actualData.invitationID);
                    templateIDs.push(user.actualData.templateID);
                }
            });
            if (templateIDs.every((val, i, arr) => val === arr[0]))
            {
                data = templateInfo.rows.filter((el) =>
                {
                    return el.templateID === templateIDs[0];
                });

                if (data.length > 0)
                {
                    templateDetails = {
                        ccEmailID: data[0].ccEmailID,
                        bccEmailID: data[0].bccEmailID,
                        templateID: data[0].templateID,
                        attachments: data[0].attachments,
                        body: data[0].body,
                        subject: data[0].subject,
                    };
                }
                else
                {
                    templateDetails = null;
                }

            } else
            {
                templateDetails = null;
            }

            openUserDialog.set(true);

            let setectedId = {
                selectedId: selectedIds.join(','),
                editAll: true,
                templateData: templateDetails,
            };
            invitationInfo.set(setectedId);
        }
    };

    const redirectToCreate = () =>
    {
        openDialog.set(true);
    };
    const handleClose = () =>
    {
         setShowLoading(false);
        openDialog.set(false);
    };
    const editUser = (info, editIndex) =>
    {
        editLoading.set({
            loading: true,
            index: editIndex
        })
        // console.log("info",info);
        return ApiHelper.get(
            APIURLConstants.EditInvitation(
                info.actualData.invitationID
            )
        )
            .then((res) =>
            {
                editLoading.set({
                    loading: false,
                    index: editIndex
                })
                let data = res.data.invitations;
                invitationInfo.set(data[0]);
                openUserDialog.set(true);
            })
    };
    const closeEditUser = () =>
    {
        openUserDialog.set(false);
    };
    const editTemplate = (info) =>
    {
        openEditTemplate.set(true);
        invitationInfo.set(info.actualData);
    };
    const closeEditTemplate = () =>
    {
        openEditTemplate.set(false);
    };

    const editSendEmail = (info, emailIndex) =>
    {
        emailLoading.set({
            loading: true,
            index: emailIndex
        });
        // openSendEmail.set(true);
        // invitationInfo.set(info.actualData);
        return ApiHelper.get(
            APIURLConstants.EditInvitation(
                info.actualData.invitationID
            )
        )
            .then((res) =>
            {
                emailLoading.set({
                    loading: false,
                    index: emailIndex
                });
                let data = res.data.invitations;
                invitationInfo.set(data[0]);
                openSendEmail.set(true);
                getInvitationList();
            })
    };
    const closeSendEmail = () =>
    {
        openSendEmail.set(false);
    };

    const deleteInvitationList = () =>
    {
        const selected = invitationList
            .get()
            .filter((user) => user.selected === true);
            const selected1 = fullData.get().filter((user) => user.selected === true);
            if (selected.length === 0 && selected1.length===0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Invitation first',
            });
        } else
        {
            let message =
                selected.length == users.get().length
                    ? 'Do you want to delete all Invitation Lists ?'
                    : 'Do you want to delete selected Invitation List ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const handlePageChange = (event, page) =>
    {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getInvitationList();
    };
    const handleConfirmation = () =>
    {
        let deleteUsers = [];
        invitationList.get().map((user) =>
        {
            if (user.selected === true)
            {
                deleteUsers.push(user.actualData.invitationID);
            }
        });
        fullData.get().map((user) =>
        {
            if (user.selected === true)
            {
                deleteUsers.push(user.actualData.invitationID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_INVITATIONLIST, {
            ids: deleteUsers.join(','),
            modifiedBy: 0,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Invitation List deleted successfully',
                    });
                    setShowSearchRec(false);
                    getInvitationList();
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else
                {
                    message = 'Invitation List deleted Successfully';
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                }
                getInvitationList();
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const downloadTemplate = () =>
    {
        generateExcelReport();
    }
    const generateExcelReport = async () =>
    {
        await ApiHelper.get(
            APIURLConstants.GET_EXCEL_INVITATION_TEMPLATE(
                eventData.get().eventID,
            )
        ).then((res) =>
        {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject)
            {
                if (finalObject.length > 0)
                {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) =>
                    {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `Upload_Invitation_Template`);
                }
            }
        });
    }

    const handleImportInvitation = (attachmentDocument) =>
    {
        if (attachmentDocument && attachmentDocument.target.files[0])
        {
            let uploadFile = attachmentDocument.target.files[0];
            if (excelFileType.includes(uploadFile.type))
            {
                let form = new FormData();
                form.append("attachedFile", uploadFile);
                form.append("eventId", eventData.attach(Downgraded).get().eventID);
                // form.append("userId", userInfo.attach(Downgraded).get().userID);
                importInvitation(form)
                    .then(response =>
                    {
                        let result = response;
                        if (result.status > 0)
                        {
                            setSnackBarProps({ openSnack: true, variant: 'success', message: result.message });

                        } else
                        {
                            setSnackBarProps({ openSnack: true, variant: 'error', message: result.message });

                        }
                    }).catch(err =>
                    {
                        console.log(err)
                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Activity import failed.' });
                    })
            } else
            {

                setSnackBarProps({ openSnack: true, variant: 'error', message: 'Invalid file format, Please upload valid excel file.' });
            }
        } else
        {
            setSnackBarProps({ openSnack: true, variant: 'error', message: 'Please select a file to upload.' });
        }
        attachmentDocument.target.value = null;
    }

    function importInvitation(obj)
    {
        return ApiHelper.post(APIURLConstants.INVITATION_EXCEL_IMPORT, obj)
            .then(result =>
            {
                return result.data;
            })
            .catch(err =>
            {
                console.log(err);
            });
    }

    return (
        <Box
        sx={{
            overflow:'auto',
            maxHeight:'calc(100vh - 70px)',
        }}
        >
            {loading.get() ? (
                <Box
                    sx={
                        loading.get()
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : props.modPermission &&
                props.modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
                    {invitationList.get() ? (
                        <DataList
                            data={invitationList.attach(Downgraded).get()}
                            allData={fullData.attach(Downgraded).get()}
                            // onCheckSelect={onCheckSelect}
                            editRow={editUser}
                            editTemplate={editTemplate}
                            editSendEmail={editSendEmail}
                            emailLoading={emailLoading.get()}
                            editLoading={editLoading.get()}
                            handleClick={redirectToCreate}
                            title={''}
                            showSendAll={false}
                            showEdit={true}
                            buttonTitle={'Add'}
                            deleteRows={deleteInvitationList}
                            editAll={editAll}
                            showSearch={true}
                            searchLabel={'Search'}
                            // pagingInfo={pagingInfo.attach(Downgraded).get()}
                            handlePageChange={handlePageChange}
                            // showSettings={true}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            modPermission={props.modPermission}
                            downloadTemplate={downloadTemplate}
                            invitationImport={true}
                            showTemplateDownload={true}
                            handleImportInvitation={handleImportInvitation}
                        // moduleToShow={"Invitation"}
                            windowDataList={true}
                            rowType={'invitation'}
                        />
                    ) : null}
                    {openDialog.get() && (
                        <UserListDialog
                            setShowLoading={setShowLoading}
                            showLoading={showLoading}
                            open={openDialog.get()}
                            title="Add Invitation"
                            handleClose={handleClose}
                            users={eventState.attach(Downgraded).get()}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getParticipants={getInvitationList}
                            invitationList={true}
                            eventParticipants={
                                users.get().length > 0
                                    ? users.attach(Downgraded).get()
                                    : []
                            }
                            invitationInfo={allInvitationInfo.attach(Downgraded).get().length > 0 ? allInvitationInfo.attach(Downgraded).get() : null}
                        />
                    )}
                    {openUserDialog.get() && (
                        <EditInvitationList
                            open={openUserDialog.get()}
                            invitationInfo={invitationInfo
                                .attach(Downgraded)
                                .get()}
                            title="Edit Invitation"
                            handleClose={closeEditUser}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getIvitationList={getInvitationList}
                        />
                    )}
                    {openEditTemplate.get() && (
                        <EditTemplate
                            open={openEditTemplate.get()}
                            invitationInfo={invitationInfo
                                .attach(Downgraded)
                                .get()}
                            title="Edit Template "
                            handleClose={closeEditTemplate}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getInvitationList={getInvitationList}
                        />
                    )}
                    {openSendEmail.get() && (
                        <SendEmail
                            open={openSendEmail.get()}
                            invitationInfo={invitationInfo
                                .attach(Downgraded)
                                .get()}
                            title="Send Email"
                            handleClose={closeSendEmail}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getInvitationList={getInvitationList}
                        />
                    )}
                    {
                        <ConfirmationDialog
                            open={deleteConfirmation.get().open}
                            message={deleteConfirmation.get().message}
                            OkButtonText={deleteConfirmation.get().OkButtonText}
                            handleCnfClick={() =>
                                handleConfirmation(deleteConfirmation)
                            }
                            onCancelClick={() =>
                            {
                                deleteConfirmation.set({
                                    ...deleteConfirmation.get(),
                                    open: false,
                                });
                            }}></ConfirmationDialog>
                    }
                </Paper>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};
export default InvitationList;
